import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';

export const firmRoutes: Routes = [
  {
    path: 'firm/sub-accounts',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'firm/sub-accounts/:id',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'firm/sandbox-users',
    component: PlatformLinkCreatorComponent
  }
];
